import {
  ArrowBoxUpIcon_default
} from "./chunk-RZOIBYOR.mjs";
export {
  ArrowBoxUpIcon_default as default
};
